const PASSWORD_ERROR_PREFIX = 'login.password.error.';
const AUTH_ERROR_PREFIX = 'login.error.';

export function tryResolveCognitoI18nError(error: string) {
  if (/Password not long enough/i.test(error)) {
    return PASSWORD_ERROR_PREFIX + 'too-short';
  }
  if (/Password must have uppercase characters/i.test(error)) {
    return PASSWORD_ERROR_PREFIX + 'no-uppercase';
  }
  if (/Password must have lowercase characters/i.test(error)) {
    return PASSWORD_ERROR_PREFIX + 'no-lowercase';
  }
  if (/Password must have numeric character/i.test(error)) {
    return PASSWORD_ERROR_PREFIX + 'no-numeric';
  }
  if (/Password must have symbol characters/i.test(error)) {
    return PASSWORD_ERROR_PREFIX + 'no-symbol';
  }
  if (/Password cannot contain the username/i.test(error)) {
    return PASSWORD_ERROR_PREFIX + 'username-not-allowed';
  }
  if (/Password cannot contain spaces/i.test(error)) {
    return PASSWORD_ERROR_PREFIX + 'spaces-not-allowed';
  }
  if (/Invalid password format/i.test(error)) {
    return PASSWORD_ERROR_PREFIX + 'invalid-format';
  }
  if (/Incorrect username or password|User does not exist/i.test(error)) {
    return AUTH_ERROR_PREFIX + 'incorrect-credentials';
  }
  if (/Attempt limit exceeded|LimitExceededException/i.test(error)) {
    return AUTH_ERROR_PREFIX + 'attempt-limit';
  }
  return AUTH_ERROR_PREFIX + 'generic';
}
